<template>
  <v-card class="payout-confirm">
    <v-card-title>Withdrawal Request Resolution</v-card-title>

    <v-card-text>
      <p>You are about to resolve the following withdrawal request:</p>
      <v-simple-table
        class="mb-5"
      >
        <tbody>
          <tr>
            <td>User's email:</td>
            <td>{{ adminPayoutRequest.user.emailAddress }}</td>
          </tr>
          <tr>
            <td>Withdrawal Amount:</td>
            <td>{{ adminPayoutRequest.amount | numberToMoney }}</td>
          </tr>
          <tr>
            <td>Payment Method:</td>
            <td>{{ adminPayoutRequest.method }}</td>
          </tr>
          <tr>
            <td>Payment Method Account Id:</td>
            <td>{{ adminPayoutRequest.accountIdentifier }}</td>
          </tr>
          <tr>
            <td>Date Requested:</td>
            <td>{{ adminPayoutRequest.timestampCreated | timestampToDate }}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <p>To mark this withdrawal request as paid you can either <strong>confirm</strong> that payment of <strong>{{ adminPayoutRequest.amount | numberToMoney }}</strong> has been sent for this request, or <strong>cancel</strong>.</p>
    </v-card-text>

    <v-card-actions
      class="mt-3"
    >
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="confirm"
      >
        <v-icon left>
          mdi-cash-check
        </v-icon>
        Confirm Payment
      </v-btn>

      <v-btn
        color="error"
        :loading="loading"
        :disabled="loading"
        @click="cancel"
      >
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'PayoutPaidConfirm',

    computed: {
      ...mapGetters([
        'adminPayoutRequest'
      ]),
    },

    data: () => ({
      loading: false
    }),

    methods: {
      ...mapActions([
        'markAsPaid',
      ]),

      // Confirm purchase.
      confirm: function () {
        this.loading = true

        this.markAsPaid(this.adminPayoutRequest.lookup).then(() => {
          this.loading = false
          this.$emit('dialogClose')
        })
      },

      // Cancel purchase.
      cancel: function () {
        this.$emit('dialogClose')
      }
    }
  }
</script>
